// Omnix/client/ui/ExtensionManager.js
import { ComponentBase } from "../core/ComponentBase.js";

export class ExtensionManager extends ComponentBase {
    constructor(config) {
        super(config);
        this.dataCrud = null;
        this.eventGroup = `${this.config.instanceId || 'userManager'}-view`;

    }

    async initialize() {
        this.dataCrud = await this.createManagedComponent("DataCrud", null, {
            instanceId: `${this.config.instanceId}-crud`,
            rpcClass: "ExtensionManagerRpc", // From CommunicatorPlugin
            schemaPath: "collections/telephonyExtensions", // From CommunicatorPlugin
            title: "PBX Extensions",
            viewConfig: {
                mode: 'grid',
                fields: [
                    { name: 'extensionNumber', label: 'Extension' },
                    { name: 'fullName', label: 'SIP User' },
                    { name: 'password', label: 'SIP Password' },
                    { name: 'outboundCallerIdNumber', label: 'Caller ID' },
                    { name: 'assignedToType', label: 'Status', render: (val, item) => val === 'unassigned' ? `<span class="badge bg-success">Available</span>` : `<span class="badge bg-warning text-dark">Assigned to ${item.assignedToType}</span>` },
                ],
            },
            formConfig: {
                fields: {
                    extensionNumber: { type: 'text', label: 'Extension Number (e.g., 1001)', required: true },
                    // --- START OF THE FIX ---
                    // Change this field to a 'reference' type.
                    // DataCrud will automatically call the 'getFieldValues' RPC method
                    // to populate this dropdown.
                    outboundCallerIdNumber: {
                        type: 'reference',
                        label: 'Outbound Caller ID (Optional)',
                        reference: {
                            collection: 'telephonyDIDs', // The collection to get options from
                            valueField: 'phoneNumber',   // The field to use as the option's value
                            displayField: 'phoneNumber'  // The field to use as the option's label
                        }
                    },
                    // --- END OF THE FIX ---
                    password: { type: 'text', label: 'SIP Password (leave blank to keep existing)', placeholder: 'Enter new password to change' }
                }
            },
            dataConfig: { autoLoad: false }
        });
        await super.initialize();
    }

    async initAfterLogin() {
        if (this.dataCrud) {
            this.dataCrud.refreshData();
        }
    }

    async render() {
        return await this.dataCrud.render();
    }

    destroy() {
        this.dataCrud?.destroy();
        super.destroy();
    }
}